import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import axios from "axios";
import { Session, http } from "@silvertours/front-shared";
import { I18nLegacy } from "@silvertours/front-legacy-shared";
import { addItemToSearchHistory, mapFormToSearchItem } from "../SearchHistory";
import { useSearchContext } from "../context";
import { SEARCH_FORM_SESSION_STORAGE_KEY } from "./useSession";
import { useSearch } from "./useSearch";
import { useAffiliate } from "./useAffiliate";
var createPayload = function(param, isInternalCall) {
    var affiliate = param.affiliate, customerAge = param.customerAge, depDate = param.depDate, depLocation = param.depLocation, destDate = param.destDate, destLocation = param.destLocation, inputValue = param.inputValue;
    var shouldSearchServiceNumbers = isInternalCall && inputValue.departure[0] === "#";
    return shouldSearchServiceNumbers ? {
        customerAge: customerAge,
        depDate: depDate,
        depLocation: {
            name: inputValue.departure
        },
        destDate: destDate
    } : {
        aff: affiliate,
        customerAge: customerAge,
        depDate: depDate,
        depLocation: depLocation,
        destDate: destDate,
        destLocation: destLocation
    };
};
export var matchError = function(axiosError) {
    var ref, ref1, ref2, ref3;
    var errorData = (ref = axiosError.response) === null || ref === void 0 ? void 0 : ref.data;
    var errors = errorData === null || errorData === void 0 ? void 0 : (ref1 = errorData.error) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.meta) === null || ref2 === void 0 ? void 0 : ref2.errors;
    if (errorData && [
        "validation_error",
        "form_validation_error"
    ].includes((ref3 = errorData.error) === null || ref3 === void 0 ? void 0 : ref3.name)) {
        if (errors && Array.isArray(errors)) {
            return {
                type: "locationError",
                message: errors[0]
            };
        }
        if (errors === null || errors === void 0 ? void 0 : errors.depDate) {
            return {
                type: "dateError",
                message: errors.depDate
            };
        }
        if (errors === null || errors === void 0 ? void 0 : errors.destDate) {
            return {
                type: "dateError",
                message: errors.destDate
            };
        }
        if (errors === null || errors === void 0 ? void 0 : errors.depLocation) {
            return {
                type: "locationError",
                message: errors.depLocation
            };
        }
        if (errors === null || errors === void 0 ? void 0 : errors.destLocation) {
            return {
                type: "locationError",
                message: errors.destLocation
            };
        }
    }
    return {
        type: "axiosError",
        message: axiosError.message
    };
};
export var useSubmitHandler = function() {
    var formatApiUrl = useSearch().formatApiUrl;
    var redirectToTradedoubler = useAffiliate().redirectToTradedoubler;
    var ref = useSearchContext(), prefilterQuery = ref.prefilterQuery, isInternalCall = ref.isInternalCall;
    var ref1 = I18nLegacy.useLocale(), language = ref1.language, market = ref1.market;
    return function() {
        var _ref = _async_to_generator(function(formState, queryParams, onSuccess, onError) {
            var openInNewWindow, payload, data, savedSearchItem, url, tdUrl, targetUrl, axiosError;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        openInNewWindow = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : false;
                        if (!formState) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        payload = createPayload(formState, isInternalCall);
                        return [
                            4,
                            http.axiosInstance.post(formatApiUrl("v1/quotes"), payload)
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (onSuccess) {
                            onSuccess(data);
                        }
                        if (data.redirectUrl) {
                            savedSearchItem = _object_spread_props(_object_spread({}, mapFormToSearchItem(formState)), {
                                language: language || "",
                                market: market || ""
                            });
                            addItemToSearchHistory(savedSearchItem);
                            Session.SessionStorageManager.setData(SEARCH_FORM_SESSION_STORAGE_KEY, formState);
                            url = [
                                data.redirectUrl,
                                queryParams,
                                prefilterQuery
                            ].filter(Boolean).join("&");
                            tdUrl = redirectToTradedoubler(url);
                            targetUrl = tdUrl || url;
                            if (openInNewWindow) {
                                window.open(targetUrl, "_blank");
                            } else {
                                window.location.assign(targetUrl);
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        axiosError = _state.sent();
                        if (axiosError && axios.isAxiosError(axiosError)) {
                            if (onError) {
                                onError(axiosError);
                            } else {
                                throw new Error(axiosError.message);
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(formState, queryParams, onSuccess, onError) {
            return _ref.apply(this, arguments);
        };
    }();
};
